var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"py-3 m-3 border-top"},[_c('b-col',[_vm._t("default",null,{"value":_vm.localValue,"input":_vm.input})],2),_c('b-col',[_vm._v(_vm._s(_vm.localValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }